import React, { useState, useEffect } from "react";
import axios from "axios";

const getBaseURL = () => {
  if (window.location.hostname === "localhost") {
    return "http://localhost:5000/api";
  }
  return "https://joygardens-backend.onrender.com/api";
};

const BASE_URL = getBaseURL();

const AdminEvents = () => {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({ title: "", description: "", date: "", image: null });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/events`);
      setEvents(response.data);
    } catch (err) {
      console.error("Error fetching events:", err);
      setError("Failed to load events. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleFileChange = (e) => {
    setForm({ ...form, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("description", form.description);
    formData.append("date", form.date);
    if (form.image) {
      formData.append("image", form.image);
    }

    try {
      if (editId) {
        // Update event
        await axios.put(`${BASE_URL}/events/${editId}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setEditId(null);
      } else {
        // Create new event
        await axios.post(`${BASE_URL}/events`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      setForm({ title: "", description: "", date: "", image: null });
      fetchEvents();
    } catch (err) {
      console.error("Error saving event:", err);
    }
  };

  const handleEdit = (event) => {
    setEditId(event._id);
    setForm({
      title: event.title,
      description: event.description,
      date: event.date.split("T")[0],
      image: null, // Do not pre-load image
    });
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/events/${id}`);
      fetchEvents();
    } catch (err) {
      console.error("Error deleting event:", err);
    }
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <h1 className="text-3xl font-bold text-center mb-6">Admin Events Management</h1>

      {/* Form */}
      <form onSubmit={handleSubmit} className="mb-8">
        <div className="grid gap-4">
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleInputChange}
            placeholder="Event Title"
            className="p-2 border rounded"
            required
          />
          <textarea
            name="description"
            value={form.description}
            onChange={handleInputChange}
            placeholder="Event Description"
            className="p-2 border rounded"
            required
          ></textarea>
          <input
            type="date"
            name="date"
            value={form.date}
            onChange={handleInputChange}
            className="p-2 border rounded"
            required
          />
          <input
            type="file"
            onChange={handleFileChange}
            className="p-2 border rounded"
          />
          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
          >
            {editId ? "Update Event" : "Create Event"}
          </button>
        </div>
      </form>

      {/* Events List */}
      {loading ? (
        <p>Loading events...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="grid gap-4">
          {events.map((event) => (
            <div
              key={event._id}
              className="border p-4 rounded shadow-md flex justify-between items-center"
            >
              <div>
                <h2 className="text-xl font-bold">{event.title}</h2>
                <p>{event.description}</p>
                <p className="text-sm text-gray-500">{new Date(event.date).toLocaleDateString()}</p>
                {event.imageUrl && (
                  <img
                    src={event.imageUrl}
                    alt={event.title}
                    className="mt-2 max-w-full h-32 object-cover"
                  />
                )}
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleEdit(event)}
                  className="bg-yellow-500 text-white py-1 px-2 rounded hover:bg-yellow-600"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(event._id)}
                  className="bg-red-500 text-white py-1 px-2 rounded hover:bg-red-600"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminEvents;
